<div class="new-proforma-dashboard-shell">
  <div class="gt-filter-container">
    <div class="col">
      <i class="fa fa-refresh gt-refresh" (click)="refresh()"></i>
    </div>
    <div class="col">
      <button type="button" class="filter-selection" [class.active]="selectedFilterType === 'PDF'" (click)="switchFilters('PDF')">PDF View</button>
      <button type="button" class="filter-selection" [class.active]="selectedFilterType === 'Efile'" (click)="switchFilters('Efile')">Efile View</button>
    </div>
    <div class="col actions">
      <button type="button" class="cancel-button" (click)="cancel()">Cancel</button>
    </div>
  </div>

  @if (showFormLoader) {
<div class="formLoader">
    <i class="fa fa-spinner fa-spin gt-refresh"></i>
  </div>
}

  @if (!showFormLoader) {
<div class="data-wrap">
    <div class="view-title">{{ selectedFilterType }} data view</div>
    @if (rowDataKeys.length > 0) {
<table class="table table-bordered form-inline custom-table">
      <tbody>
        @for (key of rowDataKeys; track $index) {
<tr>
          <td><strong>{{ key }}</strong></td>
          <td>{{ rowData[key] }}</td>
        </tr>
}
      </tbody>
    </table>
}
    @if (rowDataKeys.length === 0) {
<div class="no-data">No proforma data available for current filters.</div>
}
  </div>
}
</div>
